import Slideshow from '../Slideshow';
import PlayableMixin from '../mixins/PlayableMixin';
import UploadButton from '../UploadButton';
import {generateError} from '../../privates/validations/errors';
import * as members from '../../privates/privateMembers';
import mixin from '../../privates/utils/mixin';
import BaseGallery from '../BaseGallery';

class SlideshowGhost extends Slideshow {
    changeSlide(slideInfo) {
        const errorMessage = generateError.error_ghost_slide_input({
            propertyName: 'slideInfo',
            functionName: 'changeSlide',
            wrongValue: slideInfo
        });
        return Promise.reject(new Error(errorMessage));
    }
}

class PlayableMixinGhost extends PlayableMixin {
    next() {
        const errorMessage = generateError.error_ghost_function({
            functionName: 'next',
            compType: members._type.get(this).compType
        });
        return Promise.reject(new Error(errorMessage));
    }

    previous() {
        const errorMessage = generateError.error_ghost_function({
            functionName: 'previous',
            compType: members._type.get(this).compType
        });
        return Promise.reject(new Error(errorMessage));
    }
}

class UploadButtonGhost extends UploadButton {
    startUpload() {
        const errorMessage = generateError.error_ghost_function({
            functionName: 'startUpload',
            compType: members._type.get(this).compType
        });
        return Promise.reject(new Error(errorMessage));
    }
}

class GalleryGhost extends BaseGallery {}

mixin(SlideshowGhost.prototype, PlayableMixinGhost.prototype);
mixin(GalleryGhost.prototype, PlayableMixinGhost.prototype);

const GhostClasses = {
    SlideshowGhost,
    UploadButtonGhost,
    GalleryGhost
};

export default GhostClasses;
